import { safeLocalStorage } from './storage';
/**
 * Utility function to clear all user-specific application state on logout
 */
export const clearAppState = () => {
  // Clear user-specific localStorage items
  const keysToRemove = [
    'userSearchFormParams',
    'dismissedProfileSteps',
    'conversationList',
    'guestProfileClicks',  // Added: Clear guest profile click tracking
    'chat_draft_messages',  // Added: Clear draft messages on logout
    'pendingPurchase'      // Added: Clear pending purchases on logout
  ];

  keysToRemove.forEach(key => {
    safeLocalStorage.removeItem(key);
  });

  // Clear all userSearchCache items (they have prefix userSearchCache:)
  safeLocalStorage.keys().forEach(key => {
    if (key.startsWith('userSearchCache:')) {
      safeLocalStorage.removeItem(key);
    }
  });
};